import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { TableCell } from "~/components/TableView/TableCell";
export const CustomFieldTableHeader = /*#__PURE__*/ memo((param)=>{
    let { customFieldName, resizeHandle, style } = param;
    return /*#__PURE__*/ _jsxs(TableCell, {
        style: style,
        "data-testid": customFieldName,
        "data-disableselect": "true",
        className: classNames("p-1.5 px-2 text-grey-11", !!resizeHandle && "relative"),
        children: [
            customFieldName,
            resizeHandle
        ]
    });
});
CustomFieldTableHeader.displayName = "CustomFieldTableHeader";
